export default __webpack_public_path__ + "locales/ja-JP/SMTPSettings.json?hash=7ebbf271faddad9e0762f2766d177c59";